import { Theme } from '../styles';
import { ColorPath } from '../types/color';

export function resolveThemeColorByPath(
  theme: Theme,
  color?: ColorPath
): string | undefined {
  if (!color) {
    return undefined;
  } else if (color in theme.color.semantic) {
    return (theme.color.semantic as any)[color];
  }

  const isText = color.startsWith('text');
  const isBranding =
    color.startsWith('primary') ||
    color.startsWith('secondary') ||
    color.startsWith('thirdary');

  if (!isText && !isBranding) {
    return undefined;
  }

  const [path, type] = color.split('.');

  if (
    (isText && !(type in theme.color.text)) ||
    (isBranding && !(!type || type in theme.color.primary))
  ) {
    return undefined;
  }

  return (theme.color as any)[path][type || 'default'];
}
